import { useSelector } from 'react-redux';

import { MEDIA_TYPES } from '../../../constants';
import { STUDIO_ACTIONS } from '../constants';

const useRationOptions = () => {
  const imagesRatioOptions = useSelector((state) => state.aiStudio.imagesRatio);
  const videoRatio = useSelector((state) => state.aiStudio.videoRatio);
  const freeTextVideoRatio = useSelector((state) => state.aiStudio.freeTextVideoRatio);

  const getRatioOptions = ({ mediaType, action }) => {
    if (mediaType === MEDIA_TYPES.IMAGE && action === STUDIO_ACTIONS.CREATE_FORMATS) {
      return imagesRatioOptions;
    }

    if (mediaType === MEDIA_TYPES.VIDEO && action === STUDIO_ACTIONS.CREATE_FORMATS) {
      return videoRatio;
    }

    if (mediaType === MEDIA_TYPES.VIDEO && action === STUDIO_ACTIONS.FREE_TEXT_EDIT) {
      return freeTextVideoRatio;
    }

    return [];
  };

  return {
    getRatioOptions,
  };
};

export default useRationOptions;
